export default {
  exact_checkbox: false,
};
